import React, { useEffect, useRef, useState } from "react";

let nextId = 0;

const HeartTrail = () => {
  const [hearts, setHearts] = useState([]);
  const lastSpawn = useRef(0);

  useEffect(() => {
    const onMove = (e) => {
      const now = performance.now();
      if (now - lastSpawn.current < 90) return;
      lastSpawn.current = now;
      const id = nextId++;
      const x = e.clientX;
      const y = e.clientY;
      setHearts((prev) => [...prev, { id, x, y }]);
      setTimeout(() => {
        setHearts((prev) => prev.filter((h) => h.id !== id));
      }, 1200);
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  return (
    <div className="md-heart-trail" aria-hidden>
      {hearts.map((h) => (
        <span
          key={h.id}
          className="md-trail-heart"
          style={{ left: h.x, top: h.y }}
        >
          ❤
        </span>
      ))}
    </div>
  );
};

export default HeartTrail;
